import {api, commonApiWrapper, setAuthToken} from "@/services/common-api";
import {
    IAuthResponse,
    IAuthWithPasswordResponse,
    IGoogleLoginResponse,
    IOtpValidateResponse
} from "@/app/dashboard/models/Auth";
import {LocalStorageKeys, setStoreItem} from "@/lib/localStorage-utill";

export interface IPhoneLoginResponse {
    success: boolean;
    message?: string;
}

export const loginWithOtpApi = async (email?: string, phoneNumber?: string) => 
    commonApiWrapper<IAuthResponse>(api.post('user/login/with-otp', { 
        email,
        phoneNumber
    }));

export const loginWithGoogle = async (idToken: string) => 
    commonApiWrapper<IGoogleLoginResponse>(api.post('user/login/google-login', {}, { headers: { idToken } }));

export const loginWithEmailAndPassword = async (email: string, password: string) => 
    commonApiWrapper<IAuthWithPasswordResponse>(api.post('user/login/with-password', {
        email,
        password
    }));

export const validateOTP = async (otp: string, email?: string, phoneNumber?: string) => 
    commonApiWrapper<IOtpValidateResponse>(api.post('user/login/validate-otp', {
        email,
        phoneNumber,
        otp
    }));

export const validateUserOTP = async (otp: string, email?: string, phoneNumber?: string) => 
    commonApiWrapper<IOtpValidateResponse>(api.post('user/validate/otp', {
        email,
        phoneNumber,
        otp
    }));

export const setAccessToken = (token: string) => {
    setAuthToken(api, token);
    setStoreItem(LocalStorageKeys.AccessToken, token);
};
